import { Button, Col, Dropdown, Input, Text } from 'components';
import { Api, currencies, nations } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AddCardWeb, Card } from './';

const InputsContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 24px 0 0;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  ${(props) => (props.between ? 'justify-content: space-between;' : 'flex-wrap: wrap;')};

  @media (max-width: 1024px) {
    flex-direction: column;
    flex-wrap: unset;
    justify-content: unset;
    margin-bottom: 24px;
  }
`;

let timer;
const Settings = ({}) => {
  const [country, setCountry] = useState(null),
    [currency, setCurrency] = useState(currencies[0]),
    [visible, setVisible] = useState(false),
    [initiallyLoaded, setInitiallyLoaded] = useState(false),
    [updatingCards, setUpdatingCards] = useState(false),
    [zip, setZip] = useState(''),
    { isMobile } = useSelector((state) => state.appState),
    user = useSelector((state) => state.user),
    { t } = useTranslation(),
    userCountry = user?.billing?.country || nations.find((x) => x.value === user.country)?.value,
    userCurrency = user?.billing?.currency,
    cardsCount = user?.billing?.cards?.length || 0;

  useEffect(() => {
    setCountry(userCountry);
    setCurrency(userCurrency || 'USD');
    setZip(user?.billing?.zip);
    setInitiallyLoaded(true);
  }, []);

  useEffect(() => {
    if (!initiallyLoaded) return;
    updateInfo();
  }, [zip, currency, country]);

  function handleModal() {
    setVisible(!visible);
  }

  async function updateInfo() {
    clearTimeout(timer);

    timer = setTimeout(async () => {
      const res = await Api.post('/billing/updateInformation', { country: country, currency, zip });
    }, 500);
  }

  return (
    <React.Fragment>
      <Col wid={isMobile ? '100%' : '936px'} pad={isMobile && '0 16px'} noFlex>
        <Text h4>{t('billing.billingInformation')}</Text>

        <InputsContainer>
          <Dropdown
            rounded
            wid={isMobile ? 'calc(100% - 32px)' : '262px'}
            title={t('common.country')}
            placeholder={t('settings.selectCountry')}
            options={nations}
            selected={country}
            handleSelect={(e) => setCountry(e.value)}
          />

          <Dropdown
            rounded
            marg={isMobile ? '20px 0 0' : '0 24px'}
            wid={isMobile ? 'calc(100% - 32px)' : '102px'}
            title={t('common.currency')}
            options={currencies}
            selected={typeof currency === 'string' ? currency.toUpperCase() : currency}
            handleSelect={(e) => setCurrency(e.value)}
          />

          <Input
            rounded
            title={t('common.zipCode')}
            wid={isMobile ? 'calc(100% - 32px)' : '136px'}
            placeholder="12345"
            marg={isMobile && '20px 0 0'}
            value={zip}
            onChange={({ target }) => setZip(target.value)}
          />
        </InputsContainer>

        <Text h4 marg={isMobile ? '40px 0 24px' : '48px 0 24px'}>
          {t('billing.paymentMethod')}
        </Text>

        {!!user?.billing?.cards?.length && (
          <CardsContainer between={cardsCount >= 4}>
            {user?.billing?.cards.map((x, i) => (
              <Card
                item={x}
                key={i}
                useMarginRight={cardsCount <= 4}
                updatingCards={updatingCards}
                setUpdatingCards={setUpdatingCards}
              />
            ))}
          </CardsContainer>
        )}

        <Button
          icon="add"
          text={t('billing.addPaymentMethod')}
          big
          bordered
          onClick={handleModal}
          wid={isMobile ? 'calc(100% - 32px)' : '238px'}
        />
      </Col>

      <AddCardWeb visible={visible} closeModal={handleModal} />
    </React.Fragment>
  );
};

export default Settings;
